import { render, staticRenderFns } from "./CreateCompanyDialog.vue?vue&type=template&id=24b15e23"
import script from "./CreateCompanyDialog.vue?vue&type=script&lang=js"
export * from "./CreateCompanyDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateCompanyDialog.vue?vue&type=style&index=0&id=24b15e23&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports